"use client"

import { Mobile, PC, Tablet, Notebook } from "../../views/ReactiveMode"
import { useEffect } from "react"
import ColorTextBox from "./ColorTextBox"
import { useDispatch, useSelector } from "react-redux"
import actionTypes from "../../constants/actionTypes"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import SampleNextArrow from "./SampleNextArrow"
import SamplePrevArrow from "./SamplePrevArrow"
import { useNavigate } from "react-router-dom"

function YoutubeSlider(props) {
    const dispatch = useDispatch()
    const youtubeData = useSelector((state) => state.youtube.youtubeData[props.youtubeListId])
    const isYoutube = useSelector((state) => state.youtube.isYoutube[props.youtubeListId])
    const navigate = useNavigate()

    const settings = {
        infinite: true,
        slidesToShow: 3,
        centerPadding: "0px",
        speed: 500,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true,
    }

    const notebookSettings = {
        ...settings,
        slidesToShow: 2,
    }

    const mobileSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true,
    }

    useEffect(() => {
        if (!isYoutube || !youtubeData) {
            dispatch({
                type: actionTypes.YOUTUBE_ON,
                payload: {
                    projectId: 1,
                    youtubeListId: props.youtubeListId,
                    limit: props.limit,
                },
            })
        }
    }, [dispatch, isYoutube, youtubeData, props.youtubeListId, props.limit])

    function youtubeClickEventHandler(listId, youtubeObjectId) {
        navigate("/video/" + listId + "/" + youtubeObjectId)
    }

    function viewAllHandler() {
        // SermonVideos 페이지로 이동하면서 해당 카테고리를 선택된 상태로 전달
        navigate("/sermon-videos", {
            state: {
                selectedCategory: props.youtubeListId,
                categoryName: youtubeData?.name,
            },
        })
    }

    const renderYoutubeCard = (listData, yIndex, youtubeId) => (
        <div
            key={yIndex}
            className="youtube-card animate-on-scroll fade-in"
            onClick={() => youtubeClickEventHandler(youtubeId, listData.url)}
        >
            <div className="youtube-card-inner">
                <div className="youtube-thumbnail-container">
                    <img className="youtube-thumbnail" src={listData.imgUrl || "/placeholder.svg"} alt={listData.title} />
                    <div className="youtube-play-button">
                        <i className="fas fa-play"></i>
                    </div>
                </div>
                <div className="youtube-content">
                    <h3 className="youtube-title">{listData.title}</h3>
                    <p className="youtube-subtitle">
                        {listData.subTitle && <span className="youtube-channel">{listData.subTitle}</span>}
                        {listData.subTitle && <span className="youtube-separator">|</span>}
                        <span className="youtube-date">{listData.updateTime}</span>
                    </p>
                </div>
            </div>
        </div>
    )

    const renderLoading = () => (
        <div className="youtube-loading">
            <div className="youtube-loading-spinner"></div>
            <p>영상을 불러오는 중입니다...</p>
        </div>
    )

    return (
        <>
            <PC>
                <section className="youtube-slider-section">
                    {youtubeData ? (
                        <div className="youtube-slider-container">
                            <div className="youtube-header">
                                <ColorTextBox text={youtubeData.name} />
                                <button className="view-all-button" onClick={viewAllHandler}>
                                    <span>전체보기</span>
                                    <i className="fas fa-arrow-right"></i>
                                </button>
                            </div>
                            <div className="youtube-slider-wrapper">
                                <Slider {...settings}>
                                    {youtubeData.list
                                        .slice(0, props.limit)
                                        .map((listData, yIndex) => renderYoutubeCard(listData, yIndex, youtubeData?.youtubeId))}
                                </Slider>
                            </div>
                        </div>
                    ) : (
                        renderLoading()
                    )}
                </section>
            </PC>
            <Notebook>
                <section className="youtube-slider-section">
                    {youtubeData ? (
                        <div className="youtube-slider-container">
                            <div className="youtube-header">
                                <ColorTextBox text={youtubeData.name} />
                                <button className="view-all-button" onClick={viewAllHandler}>
                                    <span>전체보기</span>
                                    <i className="fas fa-arrow-right"></i>
                                </button>
                            </div>
                            <div className="youtube-slider-wrapper">
                                <Slider {...notebookSettings}>
                                    {youtubeData.list
                                        .slice(0, props.limit)
                                        .map((listData, yIndex) => renderYoutubeCard(listData, yIndex, youtubeData?.youtubeId))}
                                </Slider>
                            </div>
                        </div>
                    ) : (
                        renderLoading()
                    )}
                </section>
            </Notebook>
            <Tablet>
                <section className="youtube-slider-section">
                    {youtubeData ? (
                        <div className="youtube-slider-container">
                            <div className="youtube-header">
                                <ColorTextBox text={youtubeData.name} />
                                <button className="view-all-button" onClick={viewAllHandler}>
                                    <span>전체보기</span>
                                    <i className="fas fa-arrow-right"></i>
                                </button>
                            </div>
                            <div className="youtube-slider-wrapper">
                                <Slider {...mobileSettings}>
                                    {youtubeData.list
                                        .slice(0, props.limit)
                                        .map((listData, yIndex) => renderYoutubeCard(listData, yIndex, youtubeData?.youtubeId))}
                                </Slider>
                            </div>
                        </div>
                    ) : (
                        renderLoading()
                    )}
                </section>
            </Tablet>
            <Mobile>
                <section className="youtube-slider-section">
                    {youtubeData ? (
                        <div className="youtube-slider-container">
                            <div className="youtube-header">
                                <ColorTextBox text={youtubeData.name} />
                                <button className="view-all-button" onClick={viewAllHandler}>
                                    <span>전체보기</span>
                                    <i className="fas fa-arrow-right"></i>
                                </button>
                            </div>
                            <div className="youtube-slider-wrapper">
                                <Slider {...mobileSettings}>
                                    {youtubeData.list
                                        .slice(0, props.limit)
                                        .map((listData, yIndex) => renderYoutubeCard(listData, yIndex, youtubeData?.youtubeId))}
                                </Slider>
                            </div>
                        </div>
                    ) : (
                        renderLoading()
                    )}
                </section>
            </Mobile>
        </>
    )
}

export default YoutubeSlider
